import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import SignupView from '@/views/SignupView.vue'
import AppointmentView from '@/views/AppointmentView.vue'
import categorieView from '@/views/CategorieView.vue'
import BookingView from '@/views/BookingView.vue'
import UserAccountView from '@/views/UserAccount.vue'
import SearchView from '@/views/SearchView.vue'
import SalonDetail from '@/views/SalonDetail.vue'
import LoginPro from '@/views/LoginPro.vue'
import CguClient from '@/views/CguClient.vue'
import CgvClient from '@/views/CgvClient.vue'
import PolitiqueConfidentialite from '@/views/PolitiqueConfidentialite.vue'
import MentionsLegales from '@/views/MentionsLegales.vue'
import CguCgvPros from '@/views/CguCgvPros.vue'
const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/rendez-vous/:id',
    name: 'appointment',
    component: AppointmentView,
    meta: { requiresAuth: true }
  },
  {
    path: '/booking',
    name: 'booking',
    component: BookingView
  },
  {
    path: '/signup',
    name: 'signup',
    component: SignupView
  },
  {
    path: '/categorie',
    name: 'categorie',
    component: categorieView
  },
  {
    path: '/services/:categorie',
    name: 'ServiceCategory',
    component: () => import('@/views/ServiceCategory.vue'),
  },
  {
    path: '/espace-pro',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }, 
  {
    path: '/userAccount',
    name: 'userAccount',
    component: UserAccountView,
    meta: { requiresAuth: true }
    },
    {
      path: '/search',
      name: 'search',
      component: SearchView
      },
      {
  path: '/salon/:id',
  name: 'SalonDetail',
  component: SalonDetail
},
{
  path: '/espace-pro/LoginPro',
  name: 'LoginPro',
  component: LoginPro
  },
  {
    path: '/cgu',
    name: 'cgu',
    component: CguClient
    },
    {
      path: '/cgv',
      name: 'cgv',
      component: CgvClient
      },
      {
        path: '/PolitiqueConfidentialite',
        name: 'PolitiqueConfidentialite',
        component: PolitiqueConfidentialite
        },
        {
          path: '/MentionsLegales',
          name: 'MentionsLegales',
          component: MentionsLegales
          },
          {
            path: '/CguCgvPros',
            name: 'CguCgvPros',
            component: CguCgvPros
            },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 🛡️ Guard de navigation global pour vérifier l'authentification client
router.beforeEach(async (to, from, next) => {
  if (to.meta.requiresAuth) {
    const token = localStorage.getItem('clientToken')

    if (!token) {
      return next({ name: 'signup', query: { redirect: to.fullPath } })
    }

    try {
      const response = await fetch('https://b53c7d5edf32.ngrok-free.app/api/clients/verify-token', {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      if (!response.ok) {
        throw new Error('Token invalide')
      }

      next() // ✅ Token valide
    } catch (error) {  if (error.response && error.response.status === 401) {
      // Supprime le token et redirige vers la page de connexion
      localStorage.removeItem('adminToken');
      this.$router.push('/login'); // ou '/login' selon ta route
    }
      console.error('Erreur de vérification de token :', error)
      localStorage.removeItem('clientToken') // 🧹 Nettoyage du token
      next({ name: 'signup' }) // 🔁 Redirection
    }
  } else {
    next() // ✅ Route publique
  }
})

export default router
